import styled from 'styled-components';
import bgLoginQualitas from '../../../assets/images/homepage/background_login_qualitas.png'
import Button from '@/main/components/shared/button/button';
import colors from '@/main/style/colors';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #E8E8E8;
  background-image: url(${bgLoginQualitas});
  background-repeat: no-repeat;
  background-size: cover;
  overflow-x: hidden;
  z-index: 0;
  @media (max-width: 1025px) {
    background-position: center;
  }
`;

export const LoginCard = styled.div`
  position: relative;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 50vh;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
    max-width: 400px;
  }
`;

export const AreaBackButton = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

`;

export const BackButton = styled.div`
  background: #941b80;
  border-radius: 50%;
  color: white;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: filter 0.2s;
  
  &:hover {
    filter: brightness(1.1);
  }
`

export const AreaLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  width: 100%;

  img {
  width: 100%;
    max-width: 180px;
    height: auto;

    @media (max-width: 768px) {
      max-width: 120px;
    }
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.25rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
`;

export const Label = styled.label`
  font-size: 0.875rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 400;

  span {
    color: #d32f2f;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.875rem 1rem;
  font-size: 1rem;
  border: 1px solid #D0D0D0;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s;
  background-color: ${colors.white};

  &:focus {
    border-color: #9B2C91;
  }

  &::placeholder {
    color: #999;
  }
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const PasswordToggleButton = styled.button`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9B2C91;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  svg {
    font-size: 1.25rem;
  }
`;

export const ForgotPasswordLink = styled.button`
  background: none;
  border: none;
  color: #9B2C91;
  font-size: 0.875rem;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  align-self: flex-start;
  margin-top: 0.25rem;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export const LoginButton = styled(Button)`
  && {
    background-color: #9B2C91;
    color: ${colors.white};
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
    font-weight: 500;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
    margin-top: 1rem;
    transition: background-color 0.2s;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    &:hover {
      background-color: #8A2782;
    }

    &:disabled {
      background-color: #CCC;
      cursor: not-allowed;
    }

    svg {
      font-size: 1.25rem;
    }
  }
`;

export const ContainerToggle = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-top: 0.25rem;
`;

export const ButtonToggleScreen = styled.button`
  background: none;
  border: none;
  color: #9B2C91;
  font-size: 0.875rem;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export const ButtonLogin = styled(Button)`
  && {
    background-color: #9B2C91;
    color: ${colors.white};
    padding: ${({ paddingCustom }: { paddingCustom?: string }) => paddingCustom || '0.875rem 1.5rem'};
    font-size: 1rem;
    font-weight: 500;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
    margin-top: 1rem;
    transition: background-color 0.2s;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    &:hover {
      background-color: #8A2782;
    }

    &:disabled {
      background-color: #CCC;
      cursor: not-allowed;
    }

    svg {
      font-size: 1.25rem;
    }
  }
`;